"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationBasedShareTexts = exports.Subdomains = void 0;
const subdomains_1 = require("./subdomains");
Object.defineProperty(exports, "Subdomains", { enumerable: true, get: function () { return subdomains_1.Subdomains; } });
const organizationShareTexts_1 = require("./organizationShareTexts");
Object.defineProperty(exports, "OrganizationBasedShareTexts", { enumerable: true, get: function () { return organizationShareTexts_1.OrganizationBasedShareTexts; } });
